<template >
  <div class="pyro">
    <div class="before"></div>
    <div class="after"></div>
    <div
      class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="px-8 pt-8 login-tabs-container">
              <b
                ><h1>Pin : {{ respData.pin }}</h1></b
              >
              <h1 class="px-8 pt-8 mb-4">
                {{ respData.joinplay ? respData.joinplay.length : 0 }}
              </h1>
              <vs-button color="dark" type="filled">Start</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleDataList from "@/store/Poll/moduleDataList.js";
export default {
  data() {
    return {
      backgroundLoading: "#22c16b",
      mycolor: [
        "#646EFF",
        "#6478FF",
        "#6482FF",
        "#648CFF",
        "#6496FF",
        "#64A0FF",
        "#64AAFF",
        "#4169E1",
        "#4B73E1",
        "#557DE1",
        "#5F87E1",
        "#6991E1",
        "#739BE1",
        "#7DA5E1",
        "#87AFEB",
        "#91B9F5",
      ],
      timer: "",
    };
  },
  mounted() {
    this.startBG();
  },
  beforeDestroy() {
    document.body.style.background = "#f8f8f8";
    clearInterval(this.timer);
  },
  computed: {
    respData() {
      return this.$store.state.poll.respDataView || [];
    },
  },
  methods: {
    startBG() {
      this.timer = setInterval(() => {
        let mycolor = this.generator();
        document.body.style.background = mycolor;
      }, 3500);
    },
    generator: function () {
      var item = this.mycolor[Math.floor(Math.random() * this.mycolor.length)];
      return item;
    },
    openLoadingBackground() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: "rgb(255, 255, 255)",
      });
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
    },
  },
  created() {
    this.openLoadingBackground();
    document.body.style.background = this.mycolor[3];
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("poll", moduleDataList);
      moduleDataList.isRegistered = true;
    }
    var key = this.$route.params.id;
    // this.openLoadingBackground();
    this.$vs.loading();
    this.$store
      .dispatch("poll/beforeplaySetPublic", key)
      .then((res) => {
        this.$store
          .dispatch("poll/ViewData", key)
          .then((res) => {
            console.log(this.respData);
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      })
      .catch((err) => {
        this.$vs.loading.close();
      });
  },
};
</script>
<style lang="scss" scoped>
$particles: 50;
$width: 500;
$height: 500;

// Create the explosion...
$box-shadow: ();
$box-shadow2: ();
@for $i from 0 through $particles {
  $box-shadow: $box-shadow,
    random($width)-$width /
      2 +
      px
      random($height)-$height /
      1.2 +
      px
      hsl(random(360), 100, 50);
  $box-shadow2: $box-shadow2, 0 0 #fff;
}
@mixin keyframes($animationName) {
  @-webkit-keyframes #{$animationName} {
    @content;
  }

  @-moz-keyframes #{$animationName} {
    @content;
  }

  @-o-keyframes #{$animationName} {
    @content;
  }

  @-ms-keyframes #{$animationName} {
    @content;
  }

  @keyframes #{$animationName} {
    @content;
  }
}

@mixin animation-delay($settings) {
  -moz-animation-delay: $settings;
  -webkit-animation-delay: $settings;
  -o-animation-delay: $settings;
  -ms-animation-delay: $settings;
  animation-delay: $settings;
}

@mixin animation-duration($settings) {
  -moz-animation-duration: $settings;
  -webkit-animation-duration: $settings;
  -o-animation-duration: $settings;
  -ms-animation-duration: $settings;
  animation-duration: $settings;
}

@mixin animation($settings) {
  -moz-animation: $settings;
  -webkit-animation: $settings;
  -o-animation: $settings;
  -ms-animation: $settings;
  animation: $settings;
}

@mixin transform($settings) {
  transform: $settings;
  -moz-transform: $settings;
  -webkit-transform: $settings;
  -o-transform: $settings;
  -ms-transform: $settings;
}

body {
  margin: 0;
  padding: 0;
  background: #000;
  overflow: hidden;
}

.pyro > .before,
.pyro > .after {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  box-shadow: $box-shadow2;
  @include animation(
    (
      1s bang ease-out infinite backwards,
      1s gravity ease-in infinite backwards,
      5s position linear infinite backwards
    )
  );
}

.pyro > .after {
  @include animation-delay((1.25s, 1.25s, 1.25s));
  @include animation-duration((1.25s, 1.25s, 6.25s));
}

@include keyframes(bang) {
  to {
    box-shadow: $box-shadow;
  }
}

@include keyframes(gravity) {
  to {
    @include transform(translateY(200px));
    opacity: 0;
  }
}

@include keyframes(position) {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
</style>
        